import { createGlobalStyle } from 'styled-components';

export const TimerGlobalStyles = createGlobalStyle`
    .docs-ver-expired-tooltip {
      &.MuiTooltip-popper {
        .MuiTooltip-tooltip {
          width: 169px;
          padding: 8px 12px;
          ${(props) => props.theme.typography.smallText}
          line-height: 16px;
          margin-top: 8px;
        }
      }
    }
`;
